<template>
  <div>
    <div class="col-md-12">
        <h3>Clientes da base</h3>
        <div class="tabela-contatos">
            <table id="relLog" ref='tabela' class="table display table-hover table-striped" style="width: 100%">
                <thead></thead>
                <tbody></tbody>
                <tfoot></tfoot>
            </table>
        </div>
    </div>

    <component :is="comp" :data="compData" v-on:dismissModal="dismissModal" />
  </div>
</template>

<script>
import modalCostumers from './ModalCostumers.vue';
import validarTel from '../../store/modules/validarTel';

// Escapa o valor antes de jogar no HTML das celulas montadas na mao
const escapar = (valor) => String(valor === null || valor === undefined ? '' : valor)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');

// Celula com reticencias e o valor completo no title, para os campos longos
const celulaTruncada = (valor) => {
    const texto = escapar(valor);
    if(!texto) return '';
    return `<span class="celula-truncada" title="${texto}">${texto}</span>`;
};

// O backend devolve no formato aaaa-mm-dd hh:mm:ss
const formataData = (valor) => {
    if(!valor) return '';
    const [date, time] = String(valor).split(' ');
    const [year, month, day] = String(date).split('-');
    if(!year || !month || !day) return valor;
    return `${day}/${month}/${year}` + (time ? ` ${time.slice(0,5)}` : '');
};

// Pesos usados para distribuir a largura das colunas no PDF. Segue a mesma
// proporcao do "width" de cada coluna da tabela, sem a coluna de acoes (que
// nao vai para a exportacao).
const pesosPdf = [15, 9, 6, 9, 8, 9, 12, 13, 6, 8];

// Todas as colunas menos a ultima ("Acoes"), que so tem o botao de editar
const colunasExportadas = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];

// Medidas do PDF, em pontos. A4 em paisagem tem 841.89pt de largura.
const PDF = {
    largura: 841.89,
    margem: 15,
    // ATENCAO: no pdfmake o "widths" da tabela e a largura do CONTEUDO da
    // celula; o padding e somado por cima. Com 10 colunas o padding padrao
    // (4pt de cada lado) acrescenta 80pt, que era justamente o que estourava
    // a pagina e cortava "Cod. Familia" e "Atualizacao".
    padding: 2
};

export default {
    components:{modalCostumers},
    props:{
        filter: {
            type: String,
            default: ''
        },
        upList: 0
    },
    data(){
        return {
            dt: null,
            val: this.filter,
            comp: '',
            compData: ''
        }
    },
    watch:{
        upList: function(){
            this.createTable()
        },
        filter: {
            handler: function(val){
                this.createTable()
            },
            deep: true
        }
    },
    methods:{
        dismissModal(){
            this.comp = '';
            this.createTable();
        },
        ajustarColunas(){
            if(this.dt){
                this.dt.columns.adjust();
            }
        },
        createTable(){

            if (this.dt){
                $('#relLog').DataTable().destroy();
            }

            this.dt = $('#relLog').DataTable({
                // O padrao global do sistema ja usa scrollX, que nao e compativel
                // com a extensao Responsive. Com as duas ligadas as ultimas
                // colunas (incluindo o botao de editar) somem da tela.
                responsive: false,
                processing: true,
                destroy: true,
                serverSide: true,
                autoWidth: false,
                // Em TV cabem muito mais linhas do que o padrao de 10
                pageLength: 25,
                ajax:{
                    type: "GET",
                    url: '/customer_base/getclients'
                },
                // Os botoes globais (main.js) exportam em A4 retrato com largura
                // automatica: com 10 colunas o pdfmake estoura a pagina e corta o
                // conteudo a direita. Aqui redefinimos a barra de botoes desta
                // tabela para exportar em paisagem, com largura calculada.
                buttons: [
                    {
                        extend: 'excelHtml5',
                        text: '<i class="fas fa-file-excel"></i> <span class="d-none d-sm-none d-md-inline-flex d-lg-inline-flex d-xl-inline-flex">Excel</span>',
                        title: 'Clientes da base',
                        exportOptions: {
                            orthogonal: 'export',
                            columns: colunasExportadas
                        }
                    },
                    {
                        extend: 'pdfHtml5',
                        text: '<i class="fas fa-file-pdf"></i> <span class="d-none d-sm-none d-md-inline-flex d-lg-inline-flex d-xl-inline-flex">PDF</span>',
                        title: 'Clientes da base',
                        orientation: 'landscape',
                        pageSize: 'A4',
                        exportOptions: {
                            orthogonal: 'export',
                            columns: colunasExportadas
                        },
                        customize: function(doc){
                            const tabela = doc.content.find(item => item.table);
                            if(!tabela) return;

                            doc.pageMargins = [PDF.margem, 25, PDF.margem, 25];
                            doc.defaultStyle.fontSize = 7;
                            doc.styles.tableHeader.fontSize = 7;
                            doc.styles.tableHeader.alignment = 'left';
                            doc.styles.title.fontSize = 12;

                            const colunas = tabela.table.body[0].length;

                            // Padding menor que o padrao do pdfmake, e sem linha
                            // vertical, para sobrar largura para o texto
                            tabela.layout = Object.assign({}, tabela.layout, {
                                vLineWidth: () => 0,
                                paddingLeft: () => PDF.padding,
                                paddingRight: () => PDF.padding,
                                paddingTop: () => 3,
                                paddingBottom: () => 3
                            });

                            // Sem widths explicitos o pdfmake usa 'auto' e deixa a
                            // tabela mais larga que a pagina, cortando as ultimas
                            // colunas. Aqui repartimos a largura que sobra depois
                            // das margens e do padding de todas as celulas, entao
                            // o texto quebra em varias linhas em vez de sumir.
                            const disponivel = PDF.largura
                                - (PDF.margem * 2)
                                - (colunas * PDF.padding * 2)
                                - 2; // folga para o arredondamento do pdfmake

                            const pesos = (pesosPdf.length === colunas)
                                ? pesosPdf
                                : new Array(colunas).fill(1);
                            const soma = pesos.reduce((acc, peso) => acc + peso, 0);
                            tabela.table.widths = pesos.map(peso => (disponivel * peso) / soma);
                        }
                    },
                    { extend: 'pageLength' },
                    {
                        text: '<i class="fas fa-sync-alt"></i> <span class="d-none d-sm-none d-md-inline-flex d-lg-inline-flex d-xl-inline-flex">Recarregar</span>',
                        action: function(e, dt, node, config) {
                            dt.ajax.reload(null, false);
                        },
                        attr: { class: 'btn btn-primary' }
                    }
                ],
                columns: [
                    {
                        data: "name",
                        title: "Nome completo do Aluno",
                        width: "15%",
                        render: (data, type) => type === 'display' ? celulaTruncada(data) : data
                    },
                    {
                        data: "company_name",
                        title: "Curso",
                        className: "text-center",
                        width: "9%",
                        defaultContent: '',
                        render: (data, type) => type === 'display' ? celulaTruncada(data) : data
                    },
                    {
                        data: "group",
                        title: "Turma",
                        className: "text-center",
                        width: "6%",
                        defaultContent: ''
                    },
                    {
                        data: "phone",
                        className: 'text-center',
                        title: 'Telefone',
                        width: "9%",
                        render: function ( data, type, row, meta ) {
                            if(type !== 'display' && type !== 'export') return data;
                            if(!data) return '';
                            return validarTel.formata_telefone(data);
                        }
                    },
                    {
                        data: "unique_key",
                        className: 'text-center',
                        title: 'Matrícula (RA)',
                        width: "8%",
                        defaultContent: ''
                    },
                    {
                        data: "status_matricula",
                        title: "Status da Matrícula",
                        className: "text-center",
                        width: "9%",
                        defaultContent: '',
                        render: function ( data, type ) {
                            if(type !== 'display') return data;
                            if(!data) return '';
                            // Facilita a leitura a distancia numa TV
                            const chave = String(data).toLowerCase();
                            let cor = 'neutro';
                            if(chave.indexOf('ativ') === 0) cor = 'ativo';
                            else if(chave.indexOf('tranc') === 0 || chave.indexOf('inativ') === 0) cor = 'inativo';
                            else if(chave.indexOf('cancel') === 0) cor = 'cancelado';
                            return `<span class="selo selo-${cor}">${escapar(data)}</span>`;
                        }
                    },
                    {
                        data: "responsavel_nome",
                        title: "Responsável",
                        width: "12%",
                        defaultContent: '',
                        render: (data, type) => type === 'display' ? celulaTruncada(data) : data
                    },
                    {
                        data: "responsavel_email",
                        title: "E-mail do Responsável",
                        width: "13%",
                        defaultContent: '',
                        render: (data, type) => type === 'display' ? celulaTruncada(data) : data
                    },
                    {
                        data: "codigo_familia",
                        title: "Cód. Família",
                        className: "text-center",
                        width: "6%",
                        defaultContent: ''
                    },
                    {
                        data: "data_atualizacao",
                        title: "Atualização",
                        className: "text-center",
                        width: "8%",
                        defaultContent: '',
                        render: function ( data, type, row, meta ) {
                            if(type !== 'display' && type !== 'export') return data;
                            return formataData(data);
                        }
                    },
                    {
                        // className (e nao class) e a opcao reconhecida pelo DataTables
                        className: 'details-control find-data text-center coluna-acoes',
                        data: 'id',
                        title: 'Ações',
                        width: "5%",
                        orderable: false,
                        searchable: false,
                        defaultContent: '',
                        render: () => `<button type='button' class='find-data invisible-button detail-button' title='Editar contato'><i class='find-data fa fa-edit'></i></button>`
                    }
                ],
                order: [[0, 'asc']]
            })

            // A tabela nasce dentro de uma aba escondida; sem esse ajuste as
            // larguras ficam erradas quando a aba "Clientes" e aberta
            this.$nextTick(this.ajustarColunas);
        }
    },
    mounted(){
        // O layout.blade.php carrega o app.js (que monta o Vue) ANTES do main.js,
        // e e o main.js que registra os defaults do DataTables: o "dom" com a
        // barra de botoes (B) e a paginacao, o idioma e o lengthMenu. Se a tabela
        // nascer aqui direto ela perde tudo isso, e a barra so aparecia quando a
        // tabela era recriada (ao fechar o modal de edicao, por exemplo).
        // O ready do jQuery so dispara depois que os dois scripts rodaram.
        $(() => this.createTable());

        document.querySelector('#relLog tbody').addEventListener('click', (e) =>{

            if(e.target.classList.contains('find-data')){
                const tr = e.target.closest('tr');
                const row = this.dt.row( tr ).data();
                if(!row) return;
                this.compData = row;
                this.comp = 'modal-costumers'
            }

        });

        // O botao de TV troca container/container-fluid; as colunas precisam
        // ser recalculadas quando a largura disponivel muda
        window.addEventListener('resize', this.ajustarColunas);
        $('#tvSwitcher').on('click.dtCostumers', this.ajustarColunas);

        // A tabela agora nasce dentro da aba "Clientes" ja escondida pelo
        // jQuery UI, entao as larguras so ficam certas depois que ela aparece
        $('#tabs').on('tabsactivate.dtCostumers', this.ajustarColunas);
    },
    beforeDestroy(){
        window.removeEventListener('resize', this.ajustarColunas);
        $('#tvSwitcher').off('click.dtCostumers', this.ajustarColunas);
        $('#tabs').off('tabsactivate.dtCostumers', this.ajustarColunas);
    }

}
</script>

<style>
 .detail-button {
     font-size: 18px !important;
     color: #1c869a;
 }

 .detail-button:hover {
     color: #0c4955;
     transition: 0.5s;
 }

 /* A coluna de acoes nunca deve encolher a ponto de esconder o botao */
 .tabela-contatos td.coluna-acoes,
 .tabela-contatos th.coluna-acoes {
     min-width: 70px;
     white-space: nowrap;
 }

 .tabela-contatos .celula-truncada {
     display: block;
     max-width: 100%;
     overflow: hidden;
     text-overflow: ellipsis;
     white-space: nowrap;
 }

 .tabela-contatos td,
 .tabela-contatos th {
     vertical-align: middle;
 }

 .tabela-contatos thead th {
     white-space: nowrap;
 }

 /* Selo de status: leitura rapida a distancia */
 .tabela-contatos .selo {
     display: inline-block;
     padding: 0.2em 0.7em;
     border-radius: 10px;
     font-size: 0.85em;
     font-weight: 600;
     line-height: 1.6;
     white-space: nowrap;
 }

 .tabela-contatos .selo-ativo     { background-color: #e2f3e5; color: #1e7b32; }
 .tabela-contatos .selo-inativo   { background-color: #fdf1dc; color: #96620a; }
 .tabela-contatos .selo-cancelado { background-color: #fbe3e3; color: #a32020; }
 .tabela-contatos .selo-neutro    { background-color: #e8edee; color: #40575c; }

 /* --- Exibicao em TV -------------------------------------------------- */
 /* O botao "Exibição para TV" do cabecalho troca #page-container para     */
 /* container-fluid. As regras abaixo so valem nesse modo, para nao mudar  */
 /* a aparencia normal de quem usa um monitor grande no dia a dia.         */

 #page-container.container-fluid .tabela-contatos {
     width: 100%;
 }

 @media (min-width: 1600px) {
     #page-container.container-fluid .tabela-contatos table.dataTable {
         font-size: 1.05rem;
     }

     #page-container.container-fluid .tabela-contatos table.dataTable td,
     #page-container.container-fluid .tabela-contatos table.dataTable th {
         padding-top: 0.7rem;
         padding-bottom: 0.7rem;
     }

     #page-container.container-fluid .tabela-contatos .detail-button {
         font-size: 22px !important;
     }
 }

 @media (min-width: 1920px) {
     #page-container.container-fluid .tabela-contatos table.dataTable {
         font-size: 1.2rem;
     }

     #page-container.container-fluid .tabela-contatos table.dataTable td,
     #page-container.container-fluid .tabela-contatos table.dataTable th {
         padding-top: 0.9rem;
         padding-bottom: 0.9rem;
     }

     #page-container.container-fluid .tabela-contatos table.dataTable thead th {
         font-size: 1.1rem;
         letter-spacing: 0.02em;
     }

     #page-container.container-fluid .tabela-contatos .selo {
         font-size: 0.95em;
     }

     #page-container.container-fluid .tabela-contatos .detail-button {
         font-size: 26px !important;
     }
 }
</style>
